export default __webpack_public_path__ + "6371b354bd82f71f409c2abe665685db.svg";